// webinar page custom functionality
(() => {
  const slugify = (string) => {
    return string
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/--+/g, '-')
      .trim();
  };

  const getDateAttribute = (dateString, type) => {
    const date = new Date(dateString);

    const dateObj = {
      dayOfWeek: date.toLocaleDateString('en-US', { weekday: 'long' }), // Day of the week
      month: date.toLocaleString('en-US', { month: 'long' }), // Full month name
      dayOfMonth: date.getDate(), // Day of the month
      year: date.getFullYear(), // Year
    };

    return dateObj[type] || 'dateData';
  };

  const webinar = {
    showMore: false, // true = no limit, false = limit to 10
    init: () => {
      webinar.filterExpiredWebinars();
      webinar.initDetailsModal();
      webinar.initShowMore();
      webinar.showFiltered();
    },

    initDetailsModal: () => {
      const modalTriggers = [...document.querySelectorAll('.more-details-btn')];

      for (let trigger of modalTriggers) {
        trigger.removeEventListener('click', webinar.showDetailsModal);
        trigger.removeEventListener('keydown', webinar.showDetailsModal);
        trigger.addEventListener('click', webinar.showDetailsModal);
        trigger.addEventListener('keydown', webinar.showDetailsModal);
      }
    },

    showDetailsModal: (event) => {
      const webinarDetailsModal = document.querySelector('#webinar-modal');
      const modalTitle = webinarDetailsModal.querySelector('.webinar-name');
      const webinarDetailsDisplay = webinarDetailsModal.querySelector('.webinar-details');
      const webinarDate = webinarDetailsModal.querySelector('.webinar-date');
      const webinarCta = webinarDetailsModal.querySelector('.webinar-cta');
      const webinarAction = webinarDetailsModal.querySelector('.webinar-actions');

      event.preventDefault();

      const webinarModal = new bootstrap.Modal('#webinar-modal');

      if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      const eventElement = event.target;
      const triggerEl = eventElement.closest('.more-details-btn');
      const recordedWebinar = eventElement.closest('.recorded-webinar');

      if (triggerEl) {
        if (event.key === ' ') {
          event.preventDefault();
        }

        // webinars array is coming from the webinars-data.js file
        const webinar = webinars.find(
          (webinar) => slugify(webinar.title) === triggerEl.dataset.slug && slugify(webinar.date) === triggerEl.dataset.date
        );

        if (webinar && webinar.details) {
          modalTitle.innerHTML = webinar.title;
          webinarDate.innerHTML = webinar.date + (webinar.time ? ' - ' + webinar.time : '');
          webinarDetailsDisplay.innerHTML = webinar.details;
          webinarCta.dataset.id = webinar.id;

          // Set the registration URL from the trigger element's data attribute
          const registrationUrl = triggerEl.dataset.registrationUrl;
          if (registrationUrl) {
            webinarCta.href = registrationUrl;
          }
        }
        if (recordedWebinar) {
          webinarAction.classList.add('d-none');
        } else {
          webinarAction.classList.remove('d-none');
        }

        webinarModal.show();
      }
    },

    filterExpiredWebinars: () => {
      const webinarItems = document.querySelectorAll('.webinar-column');
      const upcomingSection = document.querySelector('.upcoming-webinars');
      const centralNow = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Chicago' }));
      if (webinarItems.length > 0) {
        webinarItems.forEach((item) => {
          const date = item.querySelector('.webinar-date');
          const time = item.querySelector('.webinar-time');

          const dateText = date.textContent.trim();
          let timeText = time.textContent.trim();

          timeText = timeText.replace('CST', '').trim(); // remove CST
          timeText = timeText.replace(/(\d)(AM|PM)$/i, '$1 $2'); // add space before AM/PM if missing

          const fullDateTimeStr = `${dateText} ${timeText}`;
          const webinarDate = new Date(fullDateTimeStr);

          if (webinarDate < centralNow) {
            item.remove();
          }
        });
      }

      const remainingWebinars = document.querySelectorAll('.webinar-column');

      if (remainingWebinars.length === 0 && upcomingSection) {
        upcomingSection.style.display = 'none';
      }
    },

    initShowMore: () => {
      const showMoreBtn = document.querySelector('.show-more-btn');
      if (!showMoreBtn) return;
      showMoreBtn.removeEventListener('click', webinar.handleShowMore);
      showMoreBtn.addEventListener('click', webinar.handleShowMore);
    },

    handleShowMore: () => {
      webinar.showMore = true;
      webinar.showFiltered();
    },

    showFiltered: () => {
      const webinarTemplate = (item) => {
        return `
        <div class="recorded-webinar col-sm-11 col-md-6 d-flex mb-3 mb-lg-4">
          <div class="card rounded p-3 d-flex flex-column w-100 h-100">
            <div class="card-header bg-white border-0 p-0">
              <h3 class="h4 mb-0">${item.title}</h3>
            </div>
            <div class="card-body p-0 mt-3 mb-2 flex-grow-1">
              <div class="d-flex align-items-center">
                <span class="d-none d-lg-inline-block opacity-50 align-middle me-2">
                  <svg aria-label="Date &amp; Time" xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="currentColor"><path d="M180-630h600v-130H180v130Zm0 0v-130 130Zm0 550q-24 0-42-18t-18-42v-620q0-24 18-42t42-18h65v-60h65v60h340v-60h65v60h65q24 0 42 18t18 42v307q-14.17-7.29-29.08-12.14Q796-470 780-473v-97H180v430h319q6 17 14 31.5T532-80H180Zm551 40q-78.43 0-133.72-55.28Q542-150.57 542-229t55.28-133.72Q652.57-418 731-418t133.72 55.28Q920-307.43 920-229T864.72-95.28Q809.43-40 731-40Zm58.24-88L817-156l-75-75v-112h-39v126l86.24 89Z"></path></svg>
                </span>
                <span>
                  ${getDateAttribute(item.date, 'month')} ${getDateAttribute(item.date, 'dayOfMonth')}<span>,</span>
                  ${getDateAttribute(item.date, 'year')}
                </span>
              </div>
            </div>
            <div class="card-footer bg-white border-0 p-0 mt-auto">
              <div class="mt-3 mb-lg-0">
                <a class="recording-link text-success d-inline-block border-0 px-0 me-4" href="${
                  item.recordingUrl
                }" target="_blank">
                  <svg aria-label="Play" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="m380-340 280-180-280-180v360Zm-60 220v-80H160q-33 0-56.5-23.5T80-280v-480q0-33 23.5-56.5T160-840h640q33 0 56.5 23.5T880-760v480q0 33-23.5 56.5T800-200H640v80H320ZM160-280h640v-480H160v480Zm0 0v-480 480Z"/></svg>
                  Watch Now
                </a>
                <span class="d-inline-block">
                  <a class="more-details-btn text-reset" href="#"
                  data-slug="${slugify(item.title)}"
                  data-date="${slugify(item.date)}">
                  &raquo; Learn More</a>
                </span>
              </div>
            </div>
          </div>
        </div>
      `;
      };

      let webinarHtml = '';

      // Only show recorded webinars (recordingUrl !== null)
      const recordedWebinars = webinars.filter((webinar) => webinar.recordingUrl !== null);

      recordedWebinars.forEach((item, index) => {
        if (!webinar.showMore) {
          if (index < 10) {
            webinarHtml += webinarTemplate(item);
          }
        } else {
          webinarHtml += webinarTemplate(item);
        }
      });

      const showMoreBtn = `
        <div class="col-sm-11 col-md-12 text-center mt-4 mb-5">
          <button class="show-more-btn btn btn-outline-dark btn-lg px-5" type="button">Show More</button>
        </div>
      `;
      document.querySelector('.recorded-webinars').innerHTML = recordedWebinars.length
        ? webinarHtml + (recordedWebinars.length > 10 && !webinar.showMore ? showMoreBtn : '')
        : '<h4>No recorded webinars found.</h4>';

      webinar.showMore = false;

      // reinitialize things
      webinar.initDetailsModal();
      webinar.initShowMore();
    },
  };

  webinar.init();
})();
